import { EffectivePercentAttainmentBase } from './base/effective-percent-attainment-base';

export class EffectivePercentAttainment extends EffectivePercentAttainmentBase { }